/** Crypto-currency API uses `hyu` as the currency field alias (same as queue-setting). */
export function findCryptoExchangeRate(
  rates: any[] | undefined | null,
  details: {
    cryptoCurrency?: string;
    blockchain?: string;
    networkId?: string | number;
  }
) {
  if (!rates?.length || !details?.cryptoCurrency) return undefined;
  const currency = String(details.cryptoCurrency);
  const blockchain =
    details.blockchain != null ? String(details.blockchain) : "";
  const networkId =
    details.networkId != null && details.networkId !== ""
      ? String(details.networkId)
      : "";

  return rates.find((r: any) => {
    const rateCurrency = r?.hyu ?? r?.currency ?? r?.crypto_currency;
    const rateBlockchain =
      r?.blockchain != null
        ? String(r.blockchain)
        : r?.bc != null
          ? String(r.bc)
          : "";
    const rateNetworkId =
      r?.network_id != null && r.network_id !== ""
        ? String(r.network_id)
        : r?.networkId != null && r.networkId !== ""
          ? String(r.networkId)
          : "";
    return (
      String(rateCurrency ?? "") === currency &&
      rateBlockchain === blockchain &&
      rateNetworkId === networkId
    );
  });
}
